import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getPaymentSupportCases } from 'services/PaymentsService'
import { PaymentCaseType } from 'types/payments'
import { Paging } from 'types/types'

export const usePaymentSupportCasesQuery = (paging: Paging, status?: PaymentCaseType[]) => {
  return useQuery(
    reactQueryKeys.paymentSupportCases(),
    () => getPaymentSupportCases(paging, status),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      cacheTime: 0,
      staleTime: Infinity,
      onError: error => {
        logSentryError('Error: usePaymentSupportCasesQuery', error)
      },
    }
  )
}
